import React, { useMemo } from 'react';
import Dropdown from '../../../shared/Dropdown/Dropdown';
import { trimLabel } from '../../../shared/DeviceChart';
import styles from './KPITypeSelect.module.css';

function KPITypeSelect({ value, onChange, options }) {
  const { byLabel, byValue } = useMemo(
    () =>
      (options ?? []).reduce(
        (acc, option) => {
          acc.byLabel[option.label] = option;
          acc.byValue[option.value] = option;

          return acc;
        },
        { byLabel: {}, byValue: {} }
      ),
    [options]
  );
  const selectedOption = byValue[value];
  const handleSelect = (label) => {
    const option = byLabel[label];

    if (option) {
      onChange(option.value);
    }
  };

  return (
    <div className={styles.root}>
      <Dropdown
        keyRef={true}
        showItems={3}
        selectItem={handleSelect}
        title={selectedOption?.label ? trimLabel(selectedOption.label) : 'select'}
        data={options}
      />
    </div>
  );
}

export default KPITypeSelect;
